import { apiSlice } from './apiSlice';
import { ApiResponse } from '../../types';
import type { FinanceUserBrief } from './financeApi';

export interface AuditLogItem {
  id: number;
  userId?: number | null;
  userName?: string | null;
  ipAddress?: string | null;
  action: string;
  entityType?: string | null;
  entityId?: number | null;
  description?: string | null;
  createdAt: string;
  eventDate?: string | null;
  user?: FinanceUserBrief | null;
}

export interface AuditFilters {
  page?: number;
  limit?: number;
  userId?: number;
  action?: string;
  entityType?: string;
  entityId?: number;
  dateFrom?: string; // YYYY-MM-DD
  dateTo?: string;   // YYYY-MM-DD
  search?: string;
}

export interface AuditListResponse {
  total: number;
  page: number;
  limit: number;
  items: AuditLogItem[];
}

export const auditApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLogs: builder.query<AuditListResponse, AuditFilters | undefined>({
      query: (filters) => {
        const f = (filters ?? {}) as AuditFilters;
        const params = new URLSearchParams();
        if (f.page) params.append('page', String(f.page));
        if (f.limit) params.append('limit', String(f.limit));
        if (f.userId) params.append('userId', String(f.userId));
        if (f.action) params.append('action', f.action);
        if (f.entityType) params.append('entityType', f.entityType);
        if (f.entityId) params.append('entityId', String(f.entityId));
        if (f.dateFrom) params.append('dateFrom', f.dateFrom);
        if (f.dateTo) params.append('dateTo', f.dateTo);
        if (f.search) params.append('search', f.search);
        return { url: `/audit?${params.toString()}`, method: 'GET' };
      },
      transformResponse: (response: ApiResponse<AuditListResponse>) => response.data!,
      providesTags: ['Audit']
    })
  })
});

export const { useGetAuditLogsQuery } = auditApi;


